namespace GeniuzPOS.Purchase {
    export namespace ListLastAppPurOrderService {
        export const baseUrl = 'Purchase/ListLastAppPurOrder';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ListLastAppPurOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ListLastAppPurOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Purchase/ListLastAppPurOrder/Retrieve",
            List = "Purchase/ListLastAppPurOrder/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ListLastAppPurOrderService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
